import MainTitle from "../../components/ui/MainTitle/MainTitle";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/ui/CustomButton/CustomButton";
import plusIconWhite from "../../assets/images/icons/plus-white.svg";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetAllEmailTemplatesQuery, useGetEmailTemplateSubjectsQuery } from "../../api/queries";
import { Table, TableProps } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import dots from "../../assets/images/icons/dots.svg";
import viewIcon from "../../assets/images/icons/eye-dark.svg";
import sendIcon from "../../assets/images/icons/send-green.svg";
import { EmailTemplateStatusEnum, IEmailTemplateForTable } from "../../models/EmailTemplate";
import { useEmailTemplateMutations } from "../../api/mutations/useEmailTemplateMutations";
import ConfirmPopup from "../../components/ConfirmPopup/ConfirmPopup";
import deleteIcon from "../../assets/images/icons/basket-black.svg";
import { openSuccessMessage } from "../../store/message/messageSlice";
import { handleError } from "../../helper/errorHandler";
import useAppDispatch from "../../hooks/useAppDispatch";
import TestSendAutomatedEmail from "./TestSendAutomatedEmail/TestSendAutomatedEmail";

const AutomatedEmails = () => {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [selectedIdForDelete, setSelectedIdForDelete] = useState<string | null>(null);
  const [selectedIdForTest, setSelectedIdForTest] = useState<string | null>(null);
  // const [filters, setFilters] = useState<{ from: string | null; to: string | null }>({
  //   from: null,
  //   to: null,
  // });
  const [tableParams, setTableParams] = useState<{ current: number; pageSize: number }>({
    current: 1,
    pageSize: 10,
  });
  const { deleteEmailTemplate } = useEmailTemplateMutations();
  const {
    data = { items: [], total: 0 },
    isLoading,
    refetch,
  } = useGetAllEmailTemplatesQuery({
    currentPage: tableParams.current,
    pageSize: tableParams.pageSize,
  });
  const { data: subjects = [] } = useGetEmailTemplateSubjectsQuery();

  const handleTableChange: TableProps<IEmailTemplateForTable>["onChange"] = (pagination) => {
    setTableParams({
      current: pagination.current || 1,
      pageSize: pagination.pageSize || 10,
    });
  };

  const deleteEmailTemplateFn = () => {
    deleteEmailTemplate(selectedIdForDelete!, {
      onSuccess: () => {
        dispatch(openSuccessMessage(t("EmailTemplateDeletedSuccessfully")));
        refetch();
        setSelectedIdForDelete(null);
      },
      onError: (e) => handleError(e, dispatch, t),
    });
  };

  const columns: ColumnsType<IEmailTemplateForTable> = [
    {
      title: t("EmailSubject"),
      render: (data: IEmailTemplateForTable) => {
        const subject = subjects?.find((el) => el.id === data.subject);
        if (!subject) return "-";
        return i18n.language === "en" ? subject.labelEn : subject.labelGr;
      },
    },
    {
      title: t("Languages"),
      render: (data: IEmailTemplateForTable) => {
        return data.languages.join(" • ");
      },
    },
    {
      title: t("LastEdited"),
      render: (data: IEmailTemplateForTable) => {
        return dayjs(data.lastEdited).format("DD-MM-YYYY HH:mm");
      },
    },
    {
      title: t("Status"),
      render: (data: IEmailTemplateForTable) => {
        if (data.status === EmailTemplateStatusEnum.Active) {
          return <span className={"status approved"}>{t("Active")}</span>;
        }
        if (data.status === EmailTemplateStatusEnum.Inactive) {
          return <span className={"status declined"}>{t("Inactive")}</span>;
        }
        return <span className={"status draft"}>{t("Draft")}</span>;
      },
    },
    {
      title: t("Action"),
      width: "150px",
      render: (data: IEmailTemplateForTable) => {
        return (
          <div className={"action-wrapper"}>
            <img src={dots} alt={"action"} />
            <ul className={"dropdown"}>
              <li
                className={"dropdown-item"}
                onClick={() => navigate(`/automated-emails/${data.id}`)}
              >
                <img src={viewIcon} alt={"View"} />
                {t("View")}
              </li>
              <li className={"dropdown-item"} onClick={() => setSelectedIdForTest(data.id)}>
                <img src={sendIcon} alt={"Send"} />
                {t("TestSend")}
              </li>
              <li className={"dropdown-item"} onClick={() => setSelectedIdForDelete(data.id)}>
                <img src={deleteIcon} alt={"Delete"} />
                {t("Delete")}
              </li>
            </ul>
          </div>
        );
      },
    },
  ];

  return (
    <div className={"page-content gyms-page"}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <MainTitle text={t("AutomatedEmails")} />
        <CustomButton
          text={t("AddNew")}
          type={"button"}
          typeStyle={"fill"}
          icon={plusIconWhite}
          altIcon={"add"}
          functionOnClick={() => navigate("/automated-emails/new")}
          style={{ marginBottom: "16px", width: "180px" }}
        />
      </div>

      {/* TODO Filters */}

      <Table
        className={"table"}
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={data.items}
        pagination={{ ...tableParams, total: data.total }}
        loading={isLoading}
        onChange={handleTableChange}
      />

      {selectedIdForDelete && (
        <ConfirmPopup
          title={t("AreYouSureYouWantToDeleteThisTemplate")}
          onClickYes={deleteEmailTemplateFn}
          onClickNo={() => setSelectedIdForDelete(null)}
        />
      )}

      {selectedIdForTest && (
        <TestSendAutomatedEmail
          id={selectedIdForTest}
          closePopup={() => setSelectedIdForTest(null)}
        />
      )}
    </div>
  );
};

export default AutomatedEmails;
